/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Quick view for sections/product-showcase-carousel.liquid.
 *
 * That section is custom (not part of the vendored theme.js bundle), so its
 * "choose variant" button carries the theme's standard quick-view data
 * attributes (data-action="open-modal", data-secondary-action="open-quick-view")
 * but has no JS wired up to them out of the box. This replicates the same
 * fetch-and-inject behavior the vendored theme uses for its own quick-view
 * buttons, scoped to `.showcase` so it never touches sections that already
 * have their own listener.
 */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('.showcase [data-secondary-action="open-quick-view"]');

  if (!trigger) {
    return;
  }

  event.preventDefault();

  var productUrl = trigger.getAttribute('data-product-url');

  // Same breakpoint the theme uses to skip the modal on phone/tablet ("pocket").
  if (window.matchMedia('screen and (max-width: 1023px)').matches) {
    window.location.href = productUrl;
    return;
  }

  var modal = document.getElementById(trigger.getAttribute('aria-controls'));

  if (!modal) {
    return;
  }

  modal.classList.add('is-loading');

  var url = new URL(productUrl, window.location.origin);
  url.searchParams.set('view', 'quick-view');

  fetch(url.href, {
    credentials: 'same-origin',
    method: 'GET'
  }).then(function (response) {
    return response.text();
  }).then(function (html) {
    modal.querySelector('.modal__inner').innerHTML = html;
    modal.classList.remove('is-loading');

    // Let the theme's own section registry wire up the injected product
    // section (variant selector, gallery image swap, buy buttons) the same
    // way it does for the theme's built-in quick-view triggers.
    modal.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));

    var productSection = modal.querySelector('[data-section-type="product"]');

    var cleanUp = function () {
      if (productSection) {
        modal.dispatchEvent(new CustomEvent('shopify:section:unload', {
          bubbles: true,
          detail: { sectionId: productSection.getAttribute('data-section-id') }
        }));
      }

      modal.removeEventListener('modal:closed', cleanUp);
    };

    modal.addEventListener('modal:closed', cleanUp);
  });
});

/**
 * Run the inline scripts of quick-view content (m² / pieces / glass-mesh
 * calculators, forced-CAJA price sync, gallery helpers).
 *
 * Quick-view HTML is injected with innerHTML, so its <script> tags never run.
 * Those scripts were written for the full product page: they wait for
 * DOMContentLoaded, query `document` with fixed ids and leave intervals and
 * observers running. Each script is executed with a sandboxed `document`
 * scoped to the modal content (so ids don't collide with a product page behind
 * the modal), DOMContentLoaded fires immediately, and every interval,
 * observer and document listener is released when the modal closes.
 */
(function () {
  var runQuickViewScripts = function (modal, root, productSection) {
    if (productSection.__quickViewScriptsRan) {
      return;
    }

    productSection.__quickViewScriptsRan = true;

    var intervals = [];
    var timeouts = [];
    var observers = [];
    var listeners = [];

    var scopedDocument = new Proxy(document, {
      get: function (target, prop) {
        switch (prop) {
          case 'querySelector':
            return function (selector) { return root.querySelector(selector); };
          case 'querySelectorAll':
            return function (selector) { return root.querySelectorAll(selector); };
          case 'getElementById':
            return function (id) { return root.querySelector('#' + CSS.escape(id)); };
          case 'getElementsByClassName':
            return function (name) { return root.getElementsByClassName(name); };
          case 'readyState':
            return 'complete';
          case 'addEventListener':
            return function (type, handler, options) {
              if (type === 'DOMContentLoaded' || type === 'readystatechange') {
                setTimeout(handler, 0);
                return;
              }

              document.addEventListener(type, handler, options);
              listeners.push([type, handler, options]);
            };
          case 'removeEventListener':
            return function (type, handler, options) {
              document.removeEventListener(type, handler, options);
            };
        }

        var value = target[prop];
        return typeof value === 'function' ? value.bind(target) : value;
      }
    });

    var scopedSetInterval = function () {
      var id = setInterval.apply(window, arguments);
      intervals.push(id);
      return id;
    };

    var scopedSetTimeout = function () {
      var id = setTimeout.apply(window, arguments);
      timeouts.push(id);
      return id;
    };

    var ScopedMutationObserver = function (callback) {
      var observer = new MutationObserver(callback);
      observers.push(observer);
      return observer;
    };

    root.querySelectorAll('script').forEach(function (script) {
      var type = (script.getAttribute('type') || '').toLowerCase();

      if (type && type !== 'text/javascript' && type !== 'module') {
        return;
      }

      try {
        new Function('document', 'setInterval', 'setTimeout', 'MutationObserver', script.textContent)(
          scopedDocument,
          scopedSetInterval,
          scopedSetTimeout,
          ScopedMutationObserver
        );
      } catch (error) {
        console.error('[QuickView] Error running inline script:', error);
      }
    });

    var cleanUp = function () {
      intervals.forEach(clearInterval);
      timeouts.forEach(clearTimeout);
      observers.forEach(function (observer) { observer.disconnect(); });
      listeners.forEach(function (entry) { document.removeEventListener(entry[0], entry[1], entry[2]); });
      modal.removeEventListener('modal:closed', cleanUp);
    };

    modal.addEventListener('modal:closed', cleanUp);
  };

  var watchModal = function (modal) {
    var inner = modal.querySelector('.modal__inner');

    if (!inner || inner.__quickViewWatched) {
      return;
    }

    inner.__quickViewWatched = true;

    new MutationObserver(function () {
      var productSection = inner.querySelector('[data-section-type="product"]');

      if (productSection) {
        runQuickViewScripts(modal, inner, productSection);
      }
    }).observe(inner, { childList: true });
  };

  document.querySelectorAll('[id^="modal-quick-view-"]').forEach(watchModal);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) {
          return;
        }

        if (node.matches('[id^="modal-quick-view-"]')) {
          watchModal(node);
        }

        node.querySelectorAll('[id^="modal-quick-view-"]').forEach(watchModal);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

/**
 * Fix: product gallery carousel shows the wrong image inside a quick-view
 * modal (main image doesn't match the selected thumbnail).
 *
 * Root cause is in the vendored assets/theme.js (ProductGallery._createCarousel):
 * it measures the container and initializes Flickity synchronously right when
 * the quick-view HTML is injected, before the modal has finished opening (its
 * width is still 0 mid-transition). Flickity then computes the wrong initial
 * cell position. We can't edit theme.js, so instead we watch every
 * `.product-gallery__carousel` for the moment it actually gets a real width
 * (theme.js exposes the Flickity instance on the element as `__flickity`,
 * see assets/theme.js ~line 12612) and force a `.resize()`, which makes
 * Flickity re-measure and snap to the already-correct selected index. This
 * self-heals every quick-view entry point on the site, not just the ones we
 * added today.
 */
if (window.ResizeObserver) {
  var galleryResizeObserver = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var flickity = entry.target.__flickity;

      if (flickity && entry.contentRect.width > 0) {
        flickity.resize();
      }
    });
  });

  var watchGalleryCarousels = function (root) {
    if (root.matches && root.matches('.product-gallery__carousel')) {
      galleryResizeObserver.observe(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('.product-gallery__carousel').forEach(function (el) {
        galleryResizeObserver.observe(el);
      });
    }
  };

  watchGalleryCarousels(document.body);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          watchGalleryCarousels(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}

/**
 * Variant Image Swatch King (StarApps) price labels.
 *
 * The app prints under each swatch the lowest price of every variant sharing
 * that option value, plus a "+" when prices differ (e.g. "MURO $8,632.00+"),
 * ignoring the other options already selected. This rewrites each label with
 * the exact price of the variant the shopper would get by clicking it: the
 * swatch value combined with the currently selected values of the other
 * options. When that combination does not exist, the app's label is kept.
 *
 * Swatch markup rendered by the app: `[swatch-option="option1"][orig-value]`,
 * `.swatch-selected` on the active one, and `.swatch-price-adjacent span` for
 * the price. Group swatches linking to other products are skipped.
 */
(function () {
  var formatMoney = function (cents, format) {
    var formatWithDelimiters = function (number, precision, thousands, decimal) {
      var parts = (number / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);

      return dollars + (parts[1] ? decimal + parts[1] : '');
    };

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, placeholder) {
      switch (placeholder) {
        case 'amount_no_decimals':
          return formatWithDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator':
          return formatWithDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return formatWithDelimiters(cents, 0, '.', ',');
        default:
          return formatWithDelimiters(cents, 2, ',', '.');
      }
    });
  };

  var getMoneyFormat = function () {
    return (window.vskData && window.vskData.money_format) || (window.theme && window.theme.moneyFormat) || '${{amount}}';
  };

  var getCurrentVariant = function (section, product) {
    var idInput = section.querySelector('form[action*="/cart/add"] [name="id"]');
    var variantId = idInput ? parseInt(idInput.value, 10) : null;

    return product.variants.find(function (variant) { return variant.id === variantId; }) || null;
  };

  var productCache = new WeakMap();

  var updateSection = function (section) {
    var jsonElement = section.querySelector('[data-product-json]');
    var swatches = section.querySelectorAll('.swatch-selector[swatch-option][orig-value], li[swatch-option][orig-value]');

    if (!jsonElement || !swatches.length) {
      return;
    }

    if (!productCache.has(jsonElement)) {
      try {
        productCache.set(jsonElement, JSON.parse(jsonElement.textContent).product || null);
      } catch (error) {
        productCache.set(jsonElement, null);
      }
    }

    var product = productCache.get(jsonElement);

    if (!product || !product.variants || product.variants.length < 2) {
      return;
    }

    var currentVariant = getCurrentVariant(section, product);
    var optionCount = product.options.length;
    var selectedValues = [];

    for (var i = 0; i < optionCount; i++) {
      var selectedSwatch = section.querySelector('[swatch-option="option' + (i + 1) + '"].swatch-selected');

      selectedValues[i] = selectedSwatch
        ? selectedSwatch.getAttribute('orig-value')
        : (currentVariant ? currentVariant.options[i] : null);
    }

    var moneyFormat = getMoneyFormat();

    swatches.forEach(function (swatch) {
      var priceLabel = swatch.querySelector('.swatch-price-adjacent span');
      var optionIndex = parseInt(swatch.getAttribute('swatch-option').replace('option', ''), 10) - 1;

      if (!priceLabel || isNaN(optionIndex) || optionIndex >= optionCount) {
        return;
      }

      // Remember the app's own label (it may re-render it) so it can be restored
      // when the combination does not exist.
      if (priceLabel.textContent !== priceLabel.getAttribute('data-variant-price')) {
        priceLabel.setAttribute('data-app-price', priceLabel.textContent);
      }

      var wantedValues = selectedValues.slice();
      wantedValues[optionIndex] = swatch.getAttribute('orig-value');

      var matchingVariant = product.variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return wantedValues[index] === null || value === wantedValues[index];
        });
      });

      var label = matchingVariant
        ? formatMoney(matchingVariant.price, moneyFormat)
        : priceLabel.getAttribute('data-app-price');

      priceLabel.setAttribute('data-variant-price', label);

      if (priceLabel.textContent !== label) {
        priceLabel.textContent = label;
      }
    });
  };

  var scheduled = false;

  var updateAll = function () {
    if (scheduled) {
      return;
    }

    scheduled = true;

    window.requestAnimationFrame(function () {
      scheduled = false;

      document.querySelectorAll('[data-section-type="product"]').forEach(updateSection);
    });
  };

  // The app renders (and re-renders on every selection) asynchronously, and the
  // theme dispatches variant:changed once the form's variant id is updated.
  document.addEventListener('variant:changed', updateAll);
  document.addEventListener('click', updateAll);
  document.addEventListener('change', updateAll);

  var isSwatchNode = function (node) {
    return node && node.nodeType === 1 && (node.closest('[swatch-option], .swatch-single') || node.querySelector('[swatch-option]'));
  };

  new MutationObserver(function (mutations) {
    var touchesSwatches = mutations.some(function (mutation) {
      if (mutation.type === 'attributes') {
        return mutation.target.hasAttribute('swatch-option');
      }

      return Array.prototype.some.call(mutation.addedNodes, isSwatchNode);
    });

    if (touchesSwatches) {
      updateAll();
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

  updateAll();
})();

